// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ebfa729c","96":"864ba7c5","277":"bdb0a8f3","453":"df235e49","464":"9c446715","574":"b80c1dbc","610":"6d4ee685"}[chunkId] + ".chunk.js";
};